export const FETCH_CREATE_MEMBER = 'FETCH_CREATE_MEMBER';
export const FETCH_UPDATE_MEMBER = 'FETCH_UPDATE_MEMBER';
export const FETCH_DELETE_MEMBER = 'FETCH_DELETE_MEMBER';
export const FETCH_QUIT_PROJECT = 'FETCH_QUIT_PROJECT';
export const FETCH_GET_ALL_MEMBERS = 'FETCH_GET_ALL_MEMBERS';

export const FETCH_TASK_ASSIGN = 'FETCH_TASK_ASSIGN';
export const FETCH_TASK_UNASSIGN = 'FETCH_TASK_UNASSIGN';
